import { generatePath, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { NOTIFICATION_EVIDENCES_PAGE, REQUEST_VIDEO_PAGE } from '../../../constants/app';
import { workspaceState } from '../../../storage/app';
import { NotificationAction, NotificationCore, NotificationLinkableSection } from '../../../types/notification';

export function useNotificationAction(notification?: NotificationCore, closeNotifications?: () => void) {
  const workspace = useRecoilValue(workspaceState);
  const navigate = useNavigate();

  const openRoute = (route: string, blank: boolean) => {
    if (blank) {
      window.open(
        route,
        '_blank',
        'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no, height=700px, width=1400px',
      );
    } else {
      void navigate(route, { replace: false });
      closeNotifications?.();
    }
  };

  const routeAction = (action: NotificationAction) => {
    if (!workspace || !notification) return;
    switch (action.section) {
      case NotificationLinkableSection.requestVideo: {
        const route = generatePath(REQUEST_VIDEO_PAGE.route, {
          id: workspace._id,
          ident: action.params.ident,
        });
        openRoute(route, action.blank);
        break;
      }
      case NotificationLinkableSection.alarmEvidences: {
        const route = generatePath(NOTIFICATION_EVIDENCES_PAGE.route, {
          id: workspace._id,
          notificationId: notification._id,
        });
        openRoute(route, action.blank);
        break;
      }
    }
  };

  return {
    routeAction,
  };
}
